export const MESSAGE_REMOVED_BY_MODERATOR = "Esta mensagem foi removida por um moderador.";



// WEBPACK FOOTER //
// ./constants.js